import { useTransition } from 'react';
import { ReactComponent as PlexIcon } from './plexIcon.svg';
import styles from "./plexrefreshbutton.module.css";

const PlexRefreshButton = ({server,port,library,token}) => {
    const [isPending, startTransition] = useTransition();

    const refreshPlex = () => {
        startTransition(async () => {
            await fetch("https://plex.tv/api/resources?includeHttps=1&X-Plex-Token="+token)
            .then((response) => {
                if(response.ok) return response.text()

                alert("Fail to refresh plex library");
            })
            .then(str => new window.DOMParser().parseFromString(str, "text/xml"))
            .then(data => {
                const device = data.getElementsByName(server)[0];
                const connections = device.getElementsByTagName("Connection");
                const url = connections[connections.length - 1].getAttribute('uri');
                fetch(url+"/library/sections/"+library+"/refresh/?X-Plex-Token="+token)
                .then((response) => {
                    alert(response.ok ? "Refresh of plex library successfully launched" : "Fail to refresh plex library")
                })
            });
        })
    }

    const text = 'Refresh Plex'

    return (
        <button
            type="button"
            className={`${styles.plexButton} ${isPending ? styles.loading : ''} btn`}
            onClick={refreshPlex}
            title={text}
            disabled={isPending}
        >
            <PlexIcon />
            <span className={styles.spinner + " spinner-border spinner-border-sm"} />
        </button>
    )
}

export default PlexRefreshButton